module.exports = __webpack_public_path__ + "img/plus-small-icon.1a6d61ae.svg";